import { ValueError } from "../error/ValueError.js";
/** Is a value a function? */
export function isFunction(value) {
    return typeof value === "function";
}
/** Assert that a value is a function. */
export function assertFunction(value) {
    if (typeof value !== "function")
        throw new ValueError("Must be function", value);
}
/** Function that just passes through the first argument. */
export function PASSTHROUGH(value) {
    return value;
}
/** Function that does nothing with its arguments and always returns void. */
export function BLACKHOLE(...unused) {
    return undefined;
}
